import React from 'react'
import styled from 'styled-components'
import moment from 'moment'
import { omc } from 'utils/constants'
import { Row, Col, Button, Spin, Skeleton, Image } from 'antd'
import ViewContainer from './container'
import Header from 'components/OrderTracker/Header'

const Styled = styled.div`
  .order-container {
    overflow-y: auto;
    height: 350px;
    padding-right: 10px;

    .order-box {
      border: 1px solid #b5b5b5;
      border-radius: 5px;
      padding: 10px 20px 20px 20px;
    }

    .order-box:hover {
      border: 1px solid #f99b00;
      cursor: pointer;
    }

    ::-webkit-scrollbar {
      width: 6px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px #b5b5b5;
      border-radius: 10px;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: #f99b00;
      border-radius: 10px;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: #f99b00;
    }
  }
`

export default function Index () {
  return (
    <>
      <ViewContainer>
        {({
          state,
          ordersCount,
          orders,
          isLoading,
          setIsLoading,
          redirectLink
        }) => (
          <Styled>
            <Row>
              <Col span={24} className='text-center mt-3'>
                <h2 style={{ color: 'var(--cognac)' }}>My Orders</h2>
              </Col>
            </Row>
            <Header defaultKey='my-orders' setIsLoading={setIsLoading} />
            <Spin spinning={isLoading}>
              <Row className='mb-5'>
                {state.orders.status === 1 && (
                  <Col span={22} offset={1}>
                    <Skeleton active paragraph={{ rows: 7 }} />
                  </Col>
                )}
                {state.orders.status === 2 && (
                  <Col span={22} offset={1}>
                    {ordersCount === 0 && (
                      <Row gutter={[10, 10]}>
                        <Col className='center-vh' span={10} offset={7}>
                          <Image
                            src={'/images/order-tracker/empty.png'}
                            alt=''
                            preview={false}
                          />
                        </Col>
                        <Col span={13} offset={6} className='text-center'>
                          <h2
                            style={{
                              color: 'var(--cognac)',
                              lineHeight: '40px'
                            }}
                          >
                            You currently have no ongoing orders
                          </h2>
                        </Col>
                        <Col span={24} className='text-center mt-3'>
                          <p style={{ fontSize: '18px' }}>
                            Craving for something delicious? Order from us
                            below!
                          </p>
                        </Col>
                      </Row>
                    )}
                    {ordersCount !== 0 && (
                      <Row>
                        <Col span={24}>
                          <h3 style={{ color: 'var(--cognac)' }}>
                            You have {ordersCount} ongoing orders:
                          </h3>
                        </Col>
                        <Col span={24} className='order-container mt-2'>
                          {orders &&
                            orders.map((x) => (
                              <Row
                                key={x.id}
                                className='order-box mb-2'
                                onClick={() =>
                                  redirectLink(`/my-orders/${x.id}`)
                                }
                              >
                                <Col span={24}>
                                  <p
                                    style={{
                                      fontSize: '20px',
                                      color: '#F99B00'
                                    }}
                                  >
                                    {
                                      omc.filter(
                                        (v) => v.code === x.order_mode
                                      )[0].name
                                    }
                                  </p>
                                </Col>
                                <Col span={24}>
                                  {x.delivery_now === true && (
                                    <p style={{ fontSize: '16px' }}>
                                      Your order will arrive within{' '}
                                      {x.processing_time} mins.
                                    </p>
                                  )}
                                  {x.delivery_now === false && (
                                    <p style={{ fontSize: '16px' }}>
                                      Delivery time:{' '}
                                      {moment
                                        .utc(x.delivery_date)
                                        .format('MMM D, YYYY | LT')}
                                    </p>
                                  )}
                                </Col>
                                <Col span={24}>
                                  <p
                                    style={{ fontSize: '14px', color: 'grey' }}
                                  >
                                    {x.order_mode !== 'send_shakeys' &&
                                      x.delivery_address &&
                                      `${x.delivery_address.house_number}
                              ${x.delivery_address.building}
                              ${x.delivery_address.street + ', '}
                              ${x.delivery_address.brgy_village_subd + ', '}
                              ${x.delivery_address.city + ', '}
                              ${x.delivery_address.province}`}
                                    {x.order_mode === 'send_shakeys' &&
                                      x.send_recipients &&
                                      x.send_recipients[0] &&
                                      `${x.send_recipients[0].house_number}
                              ${x.send_recipients[0].building}
                              ${x.send_recipients[0].street + ', '}
                              ${x.send_recipients[0].brgy_village_subd + ', '}
                              ${x.send_recipients[0].city + ', '}
                              ${x.send_recipients[0].province}`}
                                  </p>
                                </Col>
                              </Row>
                            ))}
                        </Col>
                      </Row>
                    )}
                    <Row className='mt-4'>
                      <Col span={18} offset={3} className='center-vh'>
                        <Button
                          className='default-btn-size'
                          block
                          type='primary'
                          onClick={() => redirectLink('/')}
                        >
                          <p style={{ fontSize: '22px' }}>Add a New Order</p>
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                )}
              </Row>
            </Spin>
          </Styled>
        )}
      </ViewContainer>
    </>
  )
}
